import React, {Component} from "react";
import Navbar from "../navbar/navbar.js";
import "../login/login.css";
import {Link} from "react-router-dom";

class Login extends Component {
    render() {
        return (
            <div>
                <Navbar/>
                <form action="https://influence.espireads.com/" method="post" className="login-form">
                    <input name="_method" type="hidden" value="POST"/>
                    <h1>Log In</h1>
                    <div className="form-group ">
                        <input type="email" className="form-control" placeholder="Email " id="UserName"
                               name="data[User][email]"/>
                    </div>
                    <div className="form-group log-status">
                        <input type="password" className="form-control" placeholder="Password" id="Password"
                               name="data[User][password]"/>
                    </div>
                    <Link style={{marginBottom: "10px !important"}} to="/signup">
                        Need an account?
                    </Link>
                    <input type="submit" className="log-btn" value="Log In"/>
                </form>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/login.js